import { useInstantSearch } from 'react-instantsearch-core';
import { useIntl } from 'react-intl';

import type { ResponsiveColorsType } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { useRouter } from '@/hooks/useRouter';
import { useRegionProvider } from '@/providers/RegionProvider';
import { theme } from '@/theme/index';

import * as S from '../FilterAppliedButton/FilterAppliedButton.styles';
import { filtersModalMessages } from '../Filters/messages';
import * as Sc from '../FiltersApplied/FiltersApplied.styles';

type ClearFiltersType = (item: string) => void;

const renderButton = (
  name: string,
  value: string,
  item: string,
  label: string,
  clearFilters: (item: string) => void,
) => (
  <S.Button onClick={() => clearFilters(item)}>
    <Flex alignItems='center' gridGap={1} justifyContent='space-between'>
      {name} {value} {label}
      <Sc.CloseIcon
        color={theme.colors.almostBlack as ResponsiveColorsType}
        name='close'
        size='l'
        variant='regular'
      />
    </Flex>
  </S.Button>
);

export const RangeAppliedButton = () => {
  const { query } = useRouter();
  const { indexUiState, setIndexUiState } = useInstantSearch();
  const { formatMessage } = useIntl();
  const {
    country: { currency },
  } = useRegionProvider();

  const [priceFrom, priceTo] = ['priceFrom', 'priceTo'].map((key) => {
    const value = query[key];
    return Array.isArray(value) ? value[0] : value || '';
  });

  const clearFilters: ClearFiltersType = (item: string) => {
    const newQuery = { ...query };
    delete newQuery?.[item];

    const [newPriceFrom, newPriceTo] = ['priceFrom', 'priceTo'].map((key) => {
      const value = newQuery[key];
      return Array.isArray(value) ? value[0] : value || '';
    });

    const updatedRrange = `${newPriceFrom}:${newPriceTo}`;

    setIndexUiState({
      ...indexUiState,
      range: {
        price: updatedRrange,
      },
      page: 1,
    });
  };

  if (!priceFrom && !priceTo) return null;

  return (
    <>
      {priceFrom &&
        renderButton(
          formatMessage(filtersModalMessages.priceFrom),
          priceFrom,
          'priceFrom',
          currency,
          clearFilters,
        )}
      {priceTo &&
        renderButton(
          formatMessage(filtersModalMessages.priceTo),
          priceTo,
          'priceTo',
          currency,
          clearFilters,
        )}
    </>
  );
};
